import React from 'react';
import { connect } from 'react-redux';

import {
  logoutStart,
} from '../../../security/authDucks';
import { openModal } from '../../modal/modalDucks';

import { getSecurityContext } from '../../../../../../shared/src/selectors/selectors';

const onLogoutClick = dispatch => () => {
  dispatch(openModal(
    'Vous allez être déconnecté. Pour accéder au book, vous devrez vous reconnecter.',
    'Se déconnecter',
    () => {
      dispatch(logoutStart());
    },
  ));
};

const HeaderUser = ({ dispatch, securityContext: { firstName, lastName }, offline }) => (
  <div className="username">
    <span className="name">{firstName + ' ' + lastName.toUpperCase()}</span>
    {!offline && (
      <span className="icone clickable" onClick={onLogoutClick(dispatch)}>
        <i className="ic ic-connect"/>
      </span>
    )}
  </div>
);

export default connect(state => ({
  securityContext: getSecurityContext(state),
  offline: state.appState.offline,
}))(HeaderUser);




// WEBPACK FOOTER //
// ./book/src/commons/components/layout/header/HeaderUser.jsx